import React, { useState } from "react";
import { Form } from "react-bootstrap";
import { Save, XCircle } from "react-bootstrap-icons";
import { SiteData, UserConstants, UserData } from "./user.types";
import CustomMultiSelect from "../../components/Custom-Multiselect/CustomMultiSelect";

type EditableRowProps = {
  user: UserData;
  siteData: SiteData[];
  onChange: (field: keyof UserData, value: any) => void;
  onSave: () => void;
  onCancel: () => void;
  checked : boolean,
  onCheckboxChange : (user: UserData) => void;
};

function EditableRow({
  siteData,
  user,
  onChange,
  onSave,
  onCancel,
  checked,
  onCheckboxChange,
}: EditableRowProps) {
  const [errors, setErrors] = useState<{ firstName?: string; lastName?: string }>({});

  /**
   * Validate it
   * @returns 
   */
  const validate = () => {
    const newErrors: { firstName?: string; lastName?: string } = {};
    if (!user.firstName.trim()) newErrors.firstName = UserConstants.ERROR_FIRSTNAME_REQUIRED;
    if (!user.lastName.trim()) newErrors.lastName = UserConstants.ERROR_LASTNAME_REQUIRED;
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  /**
   * On handle Save
   */
  const handleSave = () => {
    if (validate()) {
      onSave();
    }
  };

  /**
   * Selected multiselect items
   * @param selectedItems 
   */
  const onSiteSelectionChange = (selectedItems: string[]) => {
     onChange("siteName", selectedItems) 
  }

  return (
    <tr className="table-warning no-hover">
      <td>
        <Form.Check checked={checked} onChange={() => onCheckboxChange(user)} />
      </td>

      <td>
        <Form.Control style={{ fontWeight: 800 }}
          size="sm"
          value={user.firstName}
          onChange={(e) => onChange("firstName", e.target.value)}
          isInvalid={!!errors.firstName}
          className="white-bg"
        />
        <Form.Control.Feedback type="invalid">
          {errors.firstName}
        </Form.Control.Feedback>
      </td>

      <td>
        <Form.Control style={{ fontWeight: 800 }}
          size="sm"
          value={user.lastName}
          onChange={(e) => onChange("lastName", e.target.value)}
          isInvalid={!!errors.lastName}
          className="white-bg"
        />
        <Form.Control.Feedback type="invalid">
          {errors.lastName}
        </Form.Control.Feedback>
      </td>

      <td style={{ fontSize: "12px" }}>
        {user.email}
      </td>

      <td style={{ width:"30%", fontSize: "12px" }}>
        <CustomMultiSelect
          options={siteData}
          selected={user.siteName}
          onChange={onSiteSelectionChange}
          placeholder="Select site"
          disabled={false}
        />
      </td>

      <td>
        <Save
          className="me-3 action-icon-background-color fs-20"
          role="button"
          title="Save"
          onClick={handleSave}
        />
        <XCircle
          className="text-danger fs-20"
          role="button"
          title="Discard"
          onClick={onCancel}
        />
      </td>
    </tr>
  );
}

export default React.memo(EditableRow);